import React from "react";
import menuData from "../assets/cartaVinos.json";

function MenuPage() {
  return (
    <div>
      <section className="content-section">
        <h1>Menú</h1>
        <p>
          Nuestra carta ofrece una cuidada selección de bebidas, cócteles y
          aperitivos.
        </p>
        <ul
          style={{
            textAlign: "left",
            margin: "20px auto",
            maxWidth: "400px",
            lineHeight: "1.8",
          }}
        >
          {menuData.items.map((item, index) => (
            <li key={index}>
              <strong>{item.nombre}</strong> - {item.descripcion}
            </li>
          ))}
        </ul>
      </section>
    </div>
  );
}

export default MenuPage;
